import { styled } from "@vitality-ds/system";
import BaseDatePickerStyles from "./styles/BaseDatePicker.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseDatePicker = styled("div", BaseDatePickerStyles);